"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _default = (0, _createSvg.createSvg)('IconMenu', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M2 5H18a1 1 0 0 0 0-2H2A1 1 0 0 0 2 5zM18 15H2a1 1 0 0 0 0 2H18a1 1 0 0 0 0-2zM18 9H2a1 1 0 0 0 0 2H18a1 1 0 0 0 0-2z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));

exports.default = _default;